import { UserTypeEnum } from "common/enums/UserType.enum";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

export const API_ENDPOINTS = {
  LOGIN: "/auth/login",
  LOGIN_ADMIN: "/auth/admin/login",
  RESET_PASSWORD: "/password-reset",
  RESET_PASSWORD_REQUEST: "/password-reset",
  RESET_PASSWORD_HANDLE: "/company-info/change-password",
  GET_ME: "/auth/me",
  // admin
  RESET_PASSWORD_ADMIN: "/password-reset/admin",
  RESET_PASSWORD_HANDLE_ADMIN: "/admin/change-password",

  //Register
  CHECK_TOKEN: "/user-register/check-token",
  SELLER_REGISTER: `/user-register?type=${UserTypeEnum.COMPANY_SELLER}`,
  BUYER_REGISTER: `/user-register?type=${UserTypeEnum.COMPANY_BUYER}`,
  COMPANY_REGISTER: "/company-info",
  EMAIL_SENT: "/email-sent",
  COMPANY_INFO: "/company-info",
  COMPANY_INFO_COUNT: "/company-info/count",
  COMPANY_INFO_DELETE: "/company-info",
  COMPANY_INFO_CSV: "/company-info/download-csv",
  UPLOAD_FILE: "/upload/file",
  UPLOAD_FILE_MULTIPLE: "/upload/files",

  // Product
  PRODUCT_LIST: "/product",
  PRODUCT_DETAIL: "/product",
  CREATE_PRODUCT: "/product",
  EDIT_PRODUCT: "/product",
  DELETE_PRODUCT: "/product",
  PRODUCT_CSV: "/product/download-csv",

  // Transaction
  TRANSACTION_LIST: "/transaction",
  TRANSACTION_COUNT: "/transaction/count",
  TRANSACTION_HISTORY: "/transaction/history",
  TRANSACTION: "/transaction/product",
  TRANSACTION_DETAIL: "/transaction/detail",
  UPDATE_TRANSACTION: "/transaction",
  DELETE_TRANSACTION: "/transaction",
  TRANSACTION_CSV: "/transaction/download-csv",
  TRANSACTION_NOTIFICATION: "/transaction/notification",

  // Chat
  CHAT: "/conversation-product",
  GET_CHAT_MESSAGE: "/conversation-product/list",

  // Conversation Inquiry
  CONVERSATION_INQUIRY: "/conversation-inquiry",
  CONVERSATION_INQUIRY_DETAIL: "/conversation-inquiry",
  CONVERSATION_INQUIRY_DELETE: "/conversation-inquiry",
  CONVERSATION_INQUIRY_CSV: "/conversation-inquiry/download-csv",

  // Note
  NOTE_LIST: "/note",

  // Ranking
  RANKING_MATERIALS: "/ranking/materials",

  // Global Counter
  GLOBAL_COUNTER: "/global-counter",

  // Gamification
  ADMIN_QUESTS: "/gamification/admin/quests",
  ADMIN_QUEST_NEXT_CODE: "/gamification/admin/quests/next-code",
  ADMIN_BADGES: "/gamification/admin/badges",
  ADMIN_COMPANY_QUEST_PROGRESS: "/gamification/admin/companies/quest-progress",
  ADMIN_COMPANIES: "/gamification/admin/companies",
};
